import { Box, IconButton } from '@material-ui/core';
import close from '../../images/cross-icon.png';
import React from 'react';

const CustomCloseIcon = ({ closeIconAction, styles }) => {
    return (
        <Box>
            <Box
                component='img'
                src={close}
                alt=''
                className={styles.crossCloseIcon}
                onClick={closeIconAction}
                tabIndex={0}
                onKeyDown={e => {
                    if (e.key === 'Enter' || e.key === '') {
                        e.preventDefault();

                        closeIconAction();
                    }
                }}
                aria-label='Close'
            />
        </Box>
    );
};

export default CustomCloseIcon;
